import { useState, useEffect, useCallback, useRef } from "react";
import React from "react";

const suskaiciuotiRezultatus = (atsakymai, klausimas) => {
  if (!Array.isArray(atsakymai) || atsakymai.length === 0 || !klausimas?.name) {
    return { error: 'Invalid input data' };
  }
  
  // Filter valid answers for this question
  const validAnswers = atsakymai.filter(answer => {
    return answer?.attributes?.atsakymas?.[klausimas.name] !== undefined
      && answer?.attributes?.atsakymas?.[klausimas.name] !== null
      && answer?.attributes?.atsakymas?.[klausimas.name] !== ''
      && !isNaN(Number(answer?.attributes?.atsakymas?.[klausimas.name]));
  });
  
  if (validAnswers.length === 0) {
    return { [klausimas.name]: { average: 0 } };
  }
  
  // Calculate the average
  const sum = validAnswers.reduce((acc, answer) => {
    return acc + Number(answer.attributes.atsakymas[klausimas.name]);
  }, 0);
  
  const average = sum / validAnswers.length;
  
  return { [klausimas.name]: { average } };
};

const SuskaiciuotasAtsakymas = React.memo(({ atsakymai, klausimas, setVisi }) => {
  const [ats, setAts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const timeoutRef = useRef(null);

  const calculateResults = useCallback(() => {
    try {
      // Validate inputs directly
      if (!Array.isArray(atsakymai) || atsakymai.length === 0 || 
          !klausimas || typeof klausimas !== 'object' || !klausimas.name) {
        throw new Error('Invalid input data');
      }
      
      // Using the helper function to calculate results
      const results = suskaiciuotiRezultatus(atsakymai, klausimas);
      
      if (results.error) {
        throw new Error(results.error);
      }

      const questionScore = results[klausimas.name]?.average || 0;
      setAts(questionScore);
      if (setVisi) setVisi(questionScore);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, [atsakymai, klausimas, setVisi]);

  // Use useEffect to run the calculation when inputs change
  useEffect(() => {
    setLoading(true);
    
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    // Calculate results
    calculateResults();
    
    // Set a timeout to prevent infinite loading
    timeoutRef.current = setTimeout(() => {
      if (loading) {
        setLoading(false);
        setError('Calculation timeout');
      }
    }, 5000); // 5 second timeout
    
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [calculateResults, loading]);

  if (loading) return <div className="rezultataiAts">Skaičiuojama...</div>;
  if (error) return <div className="rezultataiAts">Klaida: {error}</div>;

  return (
    <div className="rezultataiAts">
      {!isNaN(ats) ? Math.round(ats * 2) / 2 : 'Neskaiciuojama'}
    </div>
  );
});

export default SuskaiciuotasAtsakymas;

export function round(value, step = 1.0) {
  const inv = 1.0 / step;
  return Math.round(value * inv) / inv;
}
